import React, { useState, useRef, useEffect } from 'react'
import cn from 'classnames'

import './../categories-button/index.css'

function Selectable({ children, text, style, className }) {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(open => !open)
  const ref = useRef(null)
  const supportsTouch =
    (typeof window !== 'undefined' && 'ontouchstart' in window) ||
    (typeof navigator !== 'undefined' && navigator?.msMaxTouchPoints)
  useEffect(() => {
    const handleCloseMenu = event =>
      ref.current && !ref.current.contains(event.target) && setOpen(false)
    document.addEventListener('mousedown', handleCloseMenu)
    return () => document.removeEventListener('mousedown', handleCloseMenu)
  }, [ref])
  return (
    <div
      className={cn('dropdown', className)}
      ref={ref}
      onMouseLeave={() => !supportsTouch && setOpen(false)}
      style={style}
    >
      <button
        className="drop-button d-flex align-items-center justify-content-around"
        onClick={handleOpen}
        onMouseEnter={() => !supportsTouch && setOpen(true)}
      >
        {text}
        <div className={cn('oval', open && 'oval-active')}></div>
      </button>
      <div
        className={cn(
          'dropdown-content category-dropdown-content',
          open && 'dropdown-active'
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default Selectable
